import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CustomFamiliesAdapter } from '../conectors';


@Injectable()
export class CustomOccFamiliesAdapter implements CustomFamiliesAdapter {

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
  ) {

  }

  load(code: string, professional: boolean): Observable<any> {
    let params = new HttpParams().set('professional', professional.toString());
    const url = this.occEndpoints.buildUrl('families', { urlParams: { code } });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.get<any>(url, { headers, params })
      .pipe(
        catchError((error: any) => throwError(error)),
        map((families) => {
          return families;
        }
        )
      );
  }
}

